import React from 'react';
import { useRouter } from 'next/router';
import { Link } from './Link';
import {
  AppHeader,
  ContactDetails,
  LinkCard,
  LinkCardDescriptive,
  MenuItemExpandable,
  MenuItemExpandableContact,
  MenuItemLink,
  MenuItemList,
  MenuItemLogin,
  MenuList,
  NavigationAccessibility,
  NavigationBrand,
  NavigationHeader,
  NavigationMenu,
  NavigationStart,
  NavigationToggle,
  useResizeAndLocation,
} from '@athenamortgages/athena-navigation';

export const Navigation = () => {
  const [active, setActive] = useResizeAndLocation();
  const { pathname } = useRouter();

  return (
    <AppHeader active={active}>
      <NavigationHeader>
        <NavigationBrand DynamicLink={Link} linkProps={{ href: '/', 'aria-label': 'Athena Home Loans' }} />
        <NavigationAccessibility anchor="#skip-to-content" />
        <NavigationToggle active={active} setActive={setActive} />
        <NavigationMenu active={active} setActive={setActive}>
          <MenuList>
            <MenuItemExpandable
              name="Home Loans Dropdown"
              label="HOME LOANS"
              trapezoidCoordinates={{
                width: 624,
                height: 368,
                radius: 8,
                padding: 12,
                offset: 20,
                id: 'homeLoans-trapezoid',
              }}
              active={pathname.startsWith('/home-loans')}
            >
              <MenuItemList label="Our products">
                <LinkCardDescriptive
                  label="Refinancing"
                  description="Switch and save a motza"
                  DynamicLink={Link}
                  linkProps={{ href: '/home-loans/refinancing', 'aria-label': 'Refinancing' }}
                  active={pathname.startsWith('/home-loans/refinancing')}
                />
                <LinkCardDescriptive
                  label="Buying"
                  description="Own your home sooner"
                  DynamicLink={Link}
                  linkProps={{ href: '/home-loans/buying', 'aria-label': 'Buying' }}
                  active={pathname.startsWith('/home-loans/buying')}
                />
                <LinkCardDescriptive
                  label="Investing"
                  description="Rates that invest in you"
                  DynamicLink={Link}
                  linkProps={{ href: '/home-loans/investing', 'aria-label': 'Investing' }}
                  active={pathname.startsWith('/home-loans/investing')}
                />
              </MenuItemList>
              <MenuItemList label="Product info">
                <LinkCard
                  active={pathname.startsWith('/home-loans/rates-no-fees')}
                  linkProps={{ href: '/home-loans/rates-no-fees', 'aria-label': 'Rates and no fees' }}
                  DynamicLink={Link}
                  label="Rates and no fees"
                />
                <LinkCard
                  active={pathname.startsWith('/home-loans/athena-accelerates')}
                  linkProps={{ href: '/home-loans/athena-accelerates', 'aria-label': 'Athena Accelerates' }}
                  DynamicLink={Link}
                  label="Accelerates"
                />
                <LinkCard
                  active={pathname.startsWith('/home-loans/features')}
                  linkProps={{ href: '/home-loans/features', 'aria-label': 'Features' }}
                  DynamicLink={Link}
                  label="Features"
                />
                <LinkCard
                  active={pathname.startsWith('/home-loans/eligibility')}
                  linkProps={{ href: '/home-loans/eligibility', 'aria-label': 'Eligibility' }}
                  DynamicLink={Link}
                  label="Eligibility"
                />
                <LinkCard
                  active={pathname.startsWith('/home-loans/checklist')}
                  linkProps={{ href: '/home-loans/checklist', 'aria-label': 'Checklist' }}
                  DynamicLink={Link}
                  label="Checklist"
                />
              </MenuItemList>
            </MenuItemExpandable>
            <MenuItemExpandable
              name="Calculators dropdown"
              label="Calculators"
              trapezoidCoordinates={{
                width: 330,
                height: 220,
                radius: 8,
                padding: 8,
                offset: 10,
                id: 'calculators-trapezoid',
              }}
              active={pathname.startsWith('/calculators')}
            >
              <MenuItemList label="Crunch the numbers">
                <LinkCard
                  active={pathname.startsWith('/calculators/refinancing')}
                  linkProps={{ href: '/calculators/refinancing', 'aria-label': 'Refinance Savings' }}
                  DynamicLink={Link}
                  label="Refinance Savings"
                />
                <LinkCard
                  active={pathname.startsWith('/calculators/buying')}
                  linkProps={{ href: '/calculators/buying', 'aria-label': 'Borrowing Power' }}
                  DynamicLink={Link}
                  label="Borrowing Power"
                />
              </MenuItemList>
            </MenuItemExpandable>
            <MenuItemLink
              active={pathname.startsWith('/home-loan-hacks')}
              linkProps={{ href: '/home-loan-hacks', 'aria-label': 'Home Loan Hacks' }}
              DynamicLinkType={Link}
            >
              Hacks
            </MenuItemLink>
            <MenuItemLink
              active={pathname.startsWith('/about')}
              linkProps={{ href: '/about', 'aria-label': 'About Athena' }}
              DynamicLinkType={Link}
            >
              About
            </MenuItemLink>
            <MenuItemLink
              active={pathname.startsWith('/faq/about-athena')}
              linkProps={{ href: '/faq/about-athena', 'aria-label': 'FAQ' }}
              DynamicLinkType={Link}
            >
              FAQ
            </MenuItemLink>
            <MenuItemLink
              active={pathname.startsWith('/learn')}
              linkProps={{ href: '/learn', 'aria-label': 'Home Truths' }}
              DynamicLinkType={Link}
            >
              Home Truths
            </MenuItemLink>
            <MenuItemExpandableContact
              name="contact-dropdown"
              label="CONTACT"
              trapezoidCoordinates={{
                width: 309,
                height: 416,
                radius: 8,
                padding: 12,
                offset: 15,
                id: 'contact-trapezoid',
              }}
            >
              <ContactDetails />
            </MenuItemExpandableContact>
            <MenuItemLogin url="/homehub/home" />
          </MenuList>
        </NavigationMenu>
        <NavigationStart />
      </NavigationHeader>
    </AppHeader>
  );
};
